module.exports = __webpack_public_path__ + "04_very_short_black.2b909db4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/04_very_short_black.png
// module id = MLZa
// module chunks = 0